export const ChangeLog = [
  "Improved chatbot function.",
  "Fixed some known issues",
]

export const UpdateDate = ' 2026.08.10'

export const CurrentVersion = 'V2.10.1'

export const HistoriesVersion = [
  {
    version: 'V2.10.0',
    date: '2026-07-15',
    changes: [
      "Improved localization and resolved various internationalization issues.",
      "Enhanced the annual subscription experience.",
      "Fixed known issues and improved overall stability.",
    ]
  },
  {
    version: 'V2.9.2',
    date: '2026-05-21',
    changes: [
      "Added attendance report customization capability, allowing users to flexibly configure report display content and templates based on business needs.",
      "Added payroll and attendance settings, supporting payroll cycle configuration and report time display format to improve settlement and reporting flexibility.",
      "Enhanced report export capabilities, supporting automatic report period generation based on payroll cycles and custom date range export.",
      "Added report export mode selection, supporting Basic and Advanced export modes.",
      "Added automated report email sending capability, supporting automatic sending of reports to designated email addresses after each pay period.",
      "Added employee account permission management capability, supporting batch enable/disable of App access.",
      "Added device data synchronization settings with Registration Device control for credential registration and sync rules.",
      "Optimized Chatbot customer service capabilities, enhancing online customer support and user guidance experience.",
      "Optimized Change Log popup behavior after version updates, improving display frequency and trigger logic.",
    ]
  },
  {
    version: 'V2.9.1',
    date: '2026-03-19',
    changes: [
      "Fix the display issue of app access",
      "Fix the issue of incorrect working hours display in the app report",
      "Add parameter control functionality for device registration devices",
      "Fix the issue where employee accounts cannot log in under special case",
      "Fix some known issues",
    ]
  },
  {
    version: 'V2.9.0',
    date: '2026-03-03',
    changes: [
      "Add employee application access control permissions",
      "Updated our time and attendance rules to correct daylight saving time rules.",
      "Optimize the biometric collection process.",
      "Fixed known issues",
    ]
  },
  {
    version: 'V2.8.2',
    date: '2026-01-15',
    changes: [
      "Added a compliant signing function",
      "Added options for country/region and state selection when sign-up user",
      "Optimize Admin Log and add a manual export function",
      "Fixed known issues",
    ]
  },
  {
    version: 'V2.8.1',
    date: '2025-12-23',
    changes: [
      "Remote registration card number supports synchronization to multiple devices",
      "Fixed known issues",
    ]
  },
  {
    version: 'V2.8.0',
    date: '2025-12-09',
    changes: [
      "Support handling Missed Punch correction requests submitted from the App",
      "Support single approval actions (Approve / Reject)",
      "Support batch approval operations",
      "Approval results are traceable and reviewable",
      "Updated attendance calculation logic",
      "Enhanced attendance display & query capabilities",
      "Fixed known issues",
    ]
  },
  {
    version: 'V2.7.0',
    date: '2025-10-30',
    changes: [
      "Admins need graphic verification code when logging in repeatedly within 5 seconds",
      "Added employee password reset function in personnel list",
      "Optimized 'Forgot Password' page, supporting password modification via verification code",
      "Pop-up prompt for existing fingerprints during remote registration",
      "Added timesheet color field in quickly settings",
      "Fixed issue where only 10 personnel were displayed when adding shifts in quick settings",
      "Added User Agreement and Privacy Policy when login",
      "Improved loading speed of some lists",
      "Fixed known issues",
    ]
  },
  {
    version: 'V2.6.8',
    date: '2025-09-22',
    changes: [
      "Fix the issue of date field display error in timecard report",
      "Fix the issue of error email can not modify when edit employee",
      "Fix the issue of site save error on quickly setting site module",
      "Fix the issue of device punch records can not display in calendar",
      "Fix the issue of one hour ahead when use app punch function",
      "Fix the display issue of calendar when new employee add schedule",
      "Update some known issues",
    ]
  },
  {
    version: 'V2.6.7',
    date: '2025-09-17',
    changes: [
      "Add tips for duplicate punch record with manual punch function",
      "Performance optimization of calendar function on the app",
      "Fix the issue of clock in time differs from the actual time by one hour when app timezone support DST",
      "Fix the issue of cross timezone time conversion about shift & schedule display error on the app",
      "Fix the issue of the app's punch records are not displayed on the View Attendance Punch page",
      "Update the format of the app timecard report with empty working hours",
      "Fix the issue of not refreshing attendance calendar records after saving new punch records",
      "Fix the issue of editing the schedule date error after switching the global date format on the web",
      "Add the function of switching global date formats function",
      "Will receive an email notification after adding successful subscription on the app",
      "Add department filter conditions on Person module",
      "Add verification methods filter conditions on the View Attendance Punch page",
      "Add color fields on the timesheet function",
    ]
  },
  {
    version: 'V2.6.0',
    date: '2025-09-04',
    changes: [
      "Add new interfaces and optimize old interfaces for app function",
      "Strengthen login security protection and resist malicious attack risks",
      "Fix known issues and improve system stability"
    ]
  },
  {
    version: 'V2.5.10',
    date: '2025-08-21',
    changes: [
      "Update the DST display issue on the attendance calendar",
      "Optimize the functionality of the Quick Settings module",
      "Optimize subscription functionality",
      "Upgrade the daylight saving time function and site module functionality",
      "Update the issue of automatically exported reports becoming invalid due to time zone problems",
      "Update some known issues"
    ]
  },
  {
    version: 'V2.5.7',
    date: '2025-06-25',
    changes: [
      "The person module supports remote registration of bio-templates",
      "The person module supports update device roles",
      "Add star markers for admin identification in person list",
      "Support auto sync to all devices after add/edit/delete/resign employee",
      "Support sync all employees after binding device",
      "Remove the functions of add/delete employee and update role in the 'Person in Device' page",
      "Adjust 'Add' button to 'Sync' button on the 'Device Management' module, which allows manual sync of all employee to the device",
      "Shift Schedule module changes: Remove the 'Device Select' step when add a schedule and remove the 'Sync Person' button",
    ]
  },
  {
    version: 'V2.5.1',
    date: '2025-05-14',
    changes: [
      "Update user agreement and privacy policy documents",
      "Add email field information in the personnel module",
      "Optimize the style of user feedback function",
      "Optimize the style of change logs",
      "Optimize report download/export function: support options with timezone",
      "Add module function for check-in address",
      "Optimize the functionality of the device module",
      "Add customer service chat window function",
      "New self-service features for employees on the app",
      "New subscription feature for administrators on the app",
    ]
  },
  {
    version: '2.4.11',
    date: '2025-04-10',
    changes: [
      "Optimized the display of attendance record reports",
      "Optimized the saving logic of timesheet",
      "Optimized the daylight saving time display issue of punch records",
      "Fixed some known attendance calculation issues",
      "Fixed a known report export issue",
      "Optimized the function of deleting organizations and accounts",
      "Optimized the translation of French",
      "Added OTA firmware online upgrade",
      "Add the function of automatically deleting admin logs every month",
    ]
  },
  {
    version: '2.3.10',
    date: '2025-01-21',
    changes: [
      "Fix some known issues.",
      "Optimize known UI issues.",
      "Add the function of overtime calculation and display it in the report.",
      "Supports exporting original attendance records.",
      "Support editing and deleting supplementary cards/unused schedules/shifts.",
      "Upgrade the interface of the device.",
      "Display of time zone fields added to scheduling and original attendance records.",
      "Offline devices do not support issuing command operations.",
      "Entering the wrong password five times in a row during login will lock the account for 5 minutes.",
      "Support disabling the automatic export function",
      "Schedule module adds manual calculation function",
      "Support viewing update logs for this version",
    ]
  }
]
